import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "51",
  height: "50",
  viewBox: "0 0 51 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M51 31.6017H32.3571V50H18.5357V31.6017H0V18.3983H18.5357V0H32.3571V18.3983H51V31.6017Z",
      fill: "#E7E8F0"
    }, null, -1)
  ]))]))
}
export default { render: render }